// extracted by mini-css-extract-plugin
module.exports = {"vip-only__mask":"style_vip-only__mask__ZqKLH","vip-only__text":"style_vip-only__text__i1ZYb"};